import React from 'react';
import { Link } from 'react-router-dom';
import { useAOS } from '../../hooks/useExternalLibs';
import { useLanguage } from '../../contexts/LanguageContext';

const CustomManufacturing = () => {
  // Initialize external libraries using custom hooks
  useAOS();
  
  // Get translation function
  const { t } = useLanguage();

  return (
    <div className="service-details-page">
      {/* Page Title */}
      <div className="page-title dark-background" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/Photo-Building/eid1.JPG)` }}>
        <div className="container position-relative">
          <h1>{t('customManufacturing.pageTitle')}</h1>
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/">{t('customManufacturing.breadcrumbHome')}</Link></li>
              <li><Link to="/">{t('customManufacturing.breadcrumbServices')}</Link></li>
              <li className="current">{t('customManufacturing.breadcrumbCurrent')}</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details Section */}
      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="services-list">
                <Link to="/services/custom-manufacturing" className="active">{t('customManufacturing.customManufacturing')}</Link>
                <Link to="/services/technical-support">{t('customManufacturing.technicalSupport')}</Link>
                <Link to="/services/after-sales-service">{t('customManufacturing.afterSalesService')}</Link>
                <Link to="/services/quality-assurance">{t('customManufacturing.qualityAssurance')}</Link>
                <Link to="/services/research-development">{t('customManufacturing.researchDevelopment')}</Link>
                <Link to="/services/global-supply-chain">{t('customManufacturing.globalSupplyChain')}</Link>
              </div>
            </div>
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <div className="service-content text-center">
                <img src={`${process.env.PUBLIC_URL}/assets/img/building/building-ekk.png`} alt="Custom Manufacturing" className="img-fluid services-img mx-auto d-block" />
                <h3 className="text-center">{t('customManufacturing.title')}</h3>
                <p className="text-center">
                  {t('customManufacturing.description1')}
                </p>
                <p className="text-center">
                  {t('customManufacturing.description2')}
                </p>
                <h4 className="text-center">{t('customManufacturing.capabilitiesTitle')}</h4>
                <ul className="text-start">
                  {t('customManufacturing.capabilities').map((capability, index) => (
                    <li key={index}><i className="bi bi-check-circle"></i> <span>{capability}</span></li>
                  ))}
                </ul>
                
                <h4 className="text-center">{t('customManufacturing.industryApplicationsTitle')}</h4>
                <p className="text-center">
                  {t('customManufacturing.industryApplications')}
                </p>
                
                <div className="row gy-4 mt-4">
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('customManufacturing.manufacturingPrecision')}</h5>
                      <p>{t('customManufacturing.manufacturingPrecisionDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('customManufacturing.materialExpertise')}</h5>
                      <p>{t('customManufacturing.materialExpertiseDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('customManufacturing.productionFlexibility')}</h5>
                      <p>{t('customManufacturing.productionFlexibilityDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('customManufacturing.qualityAssuranceMetric')}</h5>
                      <p>{t('customManufacturing.qualityAssuranceMetricDesc')}</p>
                    </div>
                  </div>
                </div>
                
                <h4 className="text-center">{t('customManufacturing.processTitle')}</h4>
                <p className="text-center">
                  {t('customManufacturing.processDescription')}
                </p>
                
                <div className="text-center">
                  <Link to="/contact" className="btn btn-primary">{t('customManufacturing.discussRequirements')}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services Section */}
      <section id="related-services" className="related-services section">
        <div className="container">
          <div className="section-title" data-aos="fade-up">
            <h2>{t('customManufacturing.relatedServicesTitle')}</h2>
            <p>{t('customManufacturing.relatedServicesDescription')}</p>
          </div>
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-arrow-up-from-ground-water"></i>
                </div>
                <h3>{t('customManufacturing.technicalSupport')}</h3>
                <p>{t('customManufacturing.technicalSupportDesc')}</p>
                <Link to="/services/technical-support" className="readmore stretched-link">{t('customManufacturing.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-trowel-bricks"></i>
                </div>
                <h3>{t('customManufacturing.qualityAssurance')}</h3>
                <p>{t('customManufacturing.qualityAssuranceDesc')}</p>
                <Link to="/services/quality-assurance" className="readmore stretched-link">{t('customManufacturing.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-helmet-safety"></i>
                </div>
                <h3>{t('customManufacturing.researchDevelopment')}</h3>
                <p>{t('customManufacturing.researchDevelopmentDesc')}</p>
                <Link to="/services/research-development" className="readmore stretched-link">{t('customManufacturing.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CustomManufacturing;